<template>
  <fieldset class="card">
    <div class="card-header">
      Medical History, Medications, and Lab Values
    </div>
    <div class="card-body">
      <!--            <div class="alert alert-info">Please check all that apply</div>-->
      <div class="row mb-3">
        <div class="col">
          <!--                    <i class="fa fa-info-circle text-primary d-inline" v-tooltip:top="'Family includes your parents and siblings'"></i>-->
          <label class="d-inline">
            <strong>Which of the following do you have? (Please select all that apply)</strong>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-5 text-md-right">
          <p>
            <strong>Diabetes</strong>
          </p>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-medical-conditions-diabetes"
              v-model="medical_conditions_diabetes_has"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-diabetes"
            >
              <strong>I have diabetes.</strong>
            </label>
          </div>
          <div
            v-show="medical_conditions_diabetes_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-diabetes-insulin"
              v-model="medical_conditions_diabetes_takes_insulin"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-diabetes-insulin"
            >
              I take insulin.
            </label>
          </div>
          <div
            v-show="medical_conditions_diabetes_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-diabetes-insulin-pump"
              v-model="medical_conditions_diabetes_on_insulin_pump"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-diabetes-insulin-pump"
            >
              I am on an insulin pump
            </label>
          </div>
          <div
            v-show="medical_conditions_diabetes_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-diabetes-meds"
              v-model="medical_conditions_diabetes_takes_meds"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-diabetes-meds"
            >
              I am on medicine(s) prescribed by a doctor for diabetes.
            </label>
          </div>
          <div
            v-show="medical_conditions_diabetes_takes_meds"
            class="form-group mt-3"
          >
            <label for="assessment-medical-conditions-diabetes-meds-v-models">Medications</label>
            <input
              id="assessment-medical-conditions-diabetes-meds-v-models"
              v-model="medical_conditions_diabetes_meds"
              type="text"
              class="form-control"
              placeholder="List medicine(s)"
            >
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-5 text-md-right">
          <p>
            <strong>Prediabetes</strong>
          </p>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-medical-conditions-prediabetes"
              v-model="medical_conditions_prediabetes_has"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-prediabetes"
            >
              <strong>I am prediabetic.</strong>
            </label>
          </div>
          <div
            v-show="medical_conditions_prediabetes_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-prediabetes-meds"
              v-model="medical_conditions_prediabetes_takes_meds"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-prediabetes-meds"
            >
              I am on medicine(s) prescribed by a doctor for prediabetes.
            </label>
          </div>
          <div
            v-show="medical_conditions_prediabetes_takes_meds"
            class="form-group mt-3"
          >
            >
            <label for="assessment-medical-conditions-prediabetes-meds-v-models">Medications</label>
            <input
              id="assessment-medical-conditions-prediabetes-meds-v-models"
              v-model="medical_conditions_prediabetes_meds"
              type="text"
              class="form-control"
              placeholder="List medicine(s)"
            >
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-5 text-md-right">
          <p>
            <strong>Hypertension</strong>
          </p>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-medical-conditions-hypertension"
              v-model="medical_conditions_hypertension_has"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-hypertension"
            >
              <strong>I have hypertension/high blood pressure.</strong>
            </label>
          </div>
          <div
            v-show="medical_conditions_hypertension_has"
            class="form-check mt-1"
          >
            >
            <input
              id="assessment-medical-conditions-hypertension-meds"
              v-model="medical_conditions_hypertension_takes_meds"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-hypertension-meds"
            >
              I am on medicine(s) prescribed by a doctor for hypertension.
            </label>
          </div>
          <div
            v-show="medical_conditions_hypertension_takes_meds"
            class="form-group mt-3"
          >
            <label for="assessment-medical-conditions-hypertension-meds-v-models">Medications</label>
            <input
              id="assessment-medical-conditions-hypertension-meds-v-models"
              v-model="medical_conditions_hypertension_meds"
              type="text"
              class="form-control"
              placeholder="List medicine(s)"
            >
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-5 text-md-right">
          <p>
            <strong>Kidney Disease</strong>
          </p>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-medical-conditions-kidney_disease"
              v-model="medical_conditions_kidney_disease_has"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-kidney_disease"
            >
              <strong>I have kidney disease.</strong>
            </label>
          </div>
          <div
            v-show="medical_conditions_kidney_disease_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-kidney_disease-meds"
              v-model="medical_conditions_kidney_disease_takes_meds"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-kidney_disease-meds"
            >
              I am on medicine(s) prescribed by a doctor for kidney disease.
            </label>
          </div>
          <div
            v-show="medical_conditions_kidney_disease_takes_meds"
            class="form-group mt-3"
          >
            <label for="assessment-medical-conditions-kidney_disease-meds-v-models">Medications</label>
            <input
              id="assessment-medical-conditions-kidney_disease-meds-v-models"
              v-model="medical_conditions_kidney_disease_meds"
              type="text"
              class="form-control"
              placeholder="List medicine(s)"
            >
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-5 text-md-right">
          <p>
            <strong>Cardiac (Heart) Disease</strong>
          </p>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-medical-conditions-cardiac_disease-yes"
              v-model="medical_conditions_heart_disease_has"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-cardiac_disease-yes"
            >
              <strong>I have cardiac (heart) disease.</strong>
            </label>
          </div>
          <div
            v-show="medical_conditions_heart_disease_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-cardiac_disease-stroke"
              v-model="medical_conditions_heart_disease_had_stroke"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-cardiac_disease-stroke"
            >
              I have had a stroke or strokes.
            </label>
          </div>
          <div
            v-show="medical_conditions_heart_disease_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-cardiac_disease-attacks"
              v-model="medical_conditions_heart_disease_had_heart_attack"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-cardiac_disease-attacks"
            >
              I have had a heart attack or heart attacks.
            </label>
          </div>
          <div
            v-show="medical_conditions_heart_disease_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-cardiac_disease-meds"
              v-model="medical_conditions_heart_disease_takes_meds"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-cardiac_disease-meds"
            >
              I am on medicine(s) prescribed by a doctor for cardiac (heart) disease.
            </label>
          </div>
          <div
            v-show="medical_conditions_heart_disease_takes_meds"
            class="form-group mt-3"
          >
            <label for="assessment-medical-conditions-cardiac_disease-meds-v-models">Medications</label>
            <input
              id="assessment-medical-conditions-cardiac_disease-meds-v-models"
              v-model="medical_conditions_heart_disease_meds"
              type="text"
              class="form-control"
              placeholder="List medicine(s)"
            >
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-5 text-md-right">
          <p>
            <i
              v-tooltip:top="'Cholesterol, Triglycerides, etc.'"
              class="fa fa-info-circle text-primary d-inline"
            /> <strong>High Blood Fats</strong>
          </p>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-medical-conditions-high_blood_fats"
              v-model="medical_conditions_high_blood_fats_has"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-high_blood_fats"
            >
              <strong>I have high blood fats.</strong>
            </label>
          </div>
          <div
            v-show="medical_conditions_high_blood_fats_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-high_blood_fats-meds"
              v-model="medical_conditions_high_blood_fats_takes_meds"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-high_blood_fats-meds"
            >
              I am on medicine(s) prescribed by a doctor for high blood fats.
            </label>
          </div>
          <div
            v-show="medical_conditions_high_blood_fats_takes_meds"
            class="form-group mt-3"
          >
            <label for="assessment-medical-conditions-high_blood_fats-meds-v-models">Medications</label>
            <input
              id="assessment-medical-conditions-high_blood_fats-meds-v-models"
              v-model="medical_conditions_high_blood_fats_meds"
              type="text"
              class="form-control"
              placeholder="List medicine(s)"
            >
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-5 text-md-right">
          <p>
            <strong>Liver Disease</strong>
          </p>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-medical-conditions-liver_disease"
              v-model="medical_conditions_liver_disease_has"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-liver_disease"
            >
              <strong>I have liver disease.</strong>
            </label>
          </div>
          <div
            v-show="medical_conditions_liver_disease_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-liver_disease-meds"
              v-model="medical_conditions_liver_disease_takes_meds"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-liver_disease-meds"
            >
              I am on medicine(s) prescribed by a doctor for liver_disease.
            </label>
          </div>
          <div
            v-show="medical_conditions_liver_disease_takes_meds"
            class="form-group mt-3"
          >
            <label for="assessment-medical-conditions-liver_disease-meds-v-models">Medications</label>
            <input
              id="assessment-medical-conditions-liver_disease-meds-v-models"
              v-model="medical_conditions_liver_disease_meds"
              type="text"
              class="form-control"
              placeholder="List medicine(s)"
            >
          </div>
        </div>
      </div>  
                
      <hr>

      <div class="row">
        <div class="col-md-5 text-md-right">
          <p>
            <strong>Cancer</strong>
          </p>
        </div>
        <div class="col-md-7">
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-conditions-cancer"
              v-model="medical_conditions_cancer_has"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-cancer"
            >
              <strong>I have cancer.</strong>
            </label>
          </div>
          <div
            v-show="medical_conditions_cancer_has"
            class="form-check mt-1"
          >
            <input
              id="assessment-medical-conditions-cancer-meds"
              v-model="medical_conditions_cancer_takes_meds"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-cancer-meds"
            >
              I am on medicine(s) prescribed by a doctor for cancer.
            </label>
          </div>
          <div
            v-show="medical_conditions_cancer_takes_meds"
            class="form-group mt-3"
          >
            <label for="assessment-medical-conditions-cancer-meds-v-models">Medications</label>
            <input
              id="assessment-medical-conditions-cancer-meds-v-models"
              v-model="medical_conditions_cancer_meds"
              type="text"
              class="form-control"
              placeholder="List medicine(s)"
            >
          </div>
          <div
            v-show="medical_conditions_cancer_has"
            class="form-check mt-3"
          >
            <input
              id="assessment-medical-conditions-cancer-past-yes"
              v-model="medical_conditions_cancer_has_had"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-conditions-cancer-past-yes"
            >
              <strong>I have had cancer in the past.</strong>
            </label>
          </div>
          <div
            v-show="medical_conditions_cancer_has_had"
            class="form-group mt-3"
          >
            <label for="assessment-medical-conditions-cancer-remission-desc">I am in remission for: </label>
            <input
              id="assessment-medical-conditions-cancer-remission-desc"
              v-model="medical_conditions_cancer_in_remission_for"
              type="text"
              class="form-control"
              placeholder="List cancer(s) you are in remission for, if any"
            >
          </div>
        </div>
      </div>

      <hr>

      <div class="row mb-3">
        <div class="col">
          <i
            v-tooltip:top="'Family includes your parents and siblings'"
            class="fa fa-info-circle text-primary d-inline"
          />
          <label class="d-inline">
            <strong>Which of the following do you have in your family history? (Please select all that apply)</strong>
          </label>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-5 text-md-right">
          <label>
            Diabetes
          </label>
        </div>
        <div class="col-md-6">
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-diabetes-yes"
              v-model="medical_family_history_diabetes"
              class="form-check-input"
              name="assessment_medical_family_history_diabetes"
              type="radio"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-diabetes-yes"
            >
              Yes
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-diabetes-no"
              v-model="medical_family_history_diabetes"
              class="form-check-input"
              name="assessment_medical_family_history_diabetes"
              type="radio"
              value="0"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-diabetes-no"
            >
              No
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-5 text-md-right">
          <label>
            Hypertension
          </label>
        </div>
        <div class="col-md-6">
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-hypertension-yes"
              v-model="medical_family_history_hypertension"
              class="form-check-input"
              name="assessment_medical_family_history_hypertension"
              type="radio"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-hypertension-yes"
            >
              Yes
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-hypertension-no"
              v-model="medical_family_history_hypertension"
              class="form-check-input"
              name="assessment_medical_family_history_hypertension"
              type="radio"
              value="0"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-hypertension-no"
            >
              No
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-5 text-md-right">
          <label>
            Kidney Disease
          </label>
        </div>
        <div class="col-md-6">
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-kidney_disease-yes"
              v-model="medical_family_history_kidney_disease"
              class="form-check-input"
              name="assessment_medical_family_history_kidney_disease"
              type="radio"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-kidney_disease-yes"
            >
              Yes
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-kidney_disease-no"
              v-model="medical_family_history_kidney_disease"
              class="form-check-input"
              name="assessment_medical_family_history_kidney_disease"
              type="radio"
              value="0"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-kidney_disease-no"
            >
              No
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-5 text-md-right">
          <label>
            Cardiac (Heart) Disease
          </label>
        </div>
        <div class="col-md-6">
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-cardiac_disease-yes"
              v-model="medical_family_history_heart_disease"
              class="form-check-input"
              name="assessment_medical_family_history_cardiac_disease"
              type="radio"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-cardiac_disease-yes"
            >
              Yes
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-cardiac_disease-no"
              v-model="medical_family_history_heart_disease"
              class="form-check-input"
              name="assessment_medical_family_history_cardiac_disease"
              type="radio"
              value="0"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-cardiac_disease-no"
            >
              No
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-5 text-md-right">
          <label>
            High Blood Fats <i
              v-tooltip:top="'Cholesterol, Triglycerides, etc.'"
              class="fa fa-info-circle text-primary d-inline"
            />
          </label>
        </div>
        <div class="col-md-6">
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-high_blood_fats-yes"
              v-model="medical_family_history_high_blood_fats"
              class="form-check-input"
              name="assessment_medical_family_history_high_blood_fats"
              type="radio"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-high_blood_fats-yes"
            >
              Yes
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-high_blood_fats-no"
              v-model="medical_family_history_high_blood_fats"
              class="form-check-input"
              name="assessment_medical_family_history_high_blood_fats"
              type="radio"
              value="0"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-high_blood_fats-no"
            >
              No
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-5 text-md-right">
          <label>
            Liver Disease
          </label>
        </div>
        <div class="col-md-6">
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-liver_disease-yes"
              v-model="medical_family_history_liver_disease"
              class="form-check-input"
              name="assessment_medical_family_history_liver_disease"
              type="radio"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-liver_disease-yes"
            >
              Yes
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-liver_disease-no"
              v-model="medical_family_history_liver_disease"
              class="form-check-input"
              name="assessment_medical_family_history_liver_disease"
              type="radio"
              value="0"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-liver_disease-no"
            >
              No
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 text-md-right">
          <label>
            Cancer
          </label>
        </div>
        <div class="col-md-6">
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-cancer-yes"
              v-model="medical_family_history_cancer"
              class="form-check-input"
              name="assessment_medical_family_history_cancer"
              type="radio"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-cancer-yes"
            >
              Yes
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              id="assessment-medical-family-history-cancer-no"
              v-model="medical_family_history_cancer"
              class="form-check-input"
              name="assessment_medical_family_history_cancer"
              type="radio"
              value="0"
            >
            <label
              class="form-check-label"
              for="assessment-medical-family-history-cancer-no"
            >
              No
            </label>
          </div>
        </div>    
      </div>  

      <hr>

      <div class="row">
        <div class="col-md-5 text-md-right">
          <p>
            <strong>Other medication(s)</strong>
          </p>
        </div>
        <div class="col-md-7">
          <div class="form-check">
            <input
              id="assessment-medical-takes-herbal-meds"
              v-model="medical_meds_herbal_takes"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-takes-herbal-meds"
            >
              <strong>I take herbal medication(s).</strong>
            </label>
          </div>
          <div
            v-show="medical_meds_herbal_takes"
            class="form-group mt-3"
          >
            <label for="assessment-medical-herbal-meds-desc">What herbal medicines do you take?</label>    
            <input
              id="assessment-medical-herbal-meds-desc"
              v-model="medical_meds_herbal_description"
              type="text"
              class="form-control"
              placeholder="List medication(s)"
            >
          </div>
          <div class="form-check">
            <input
              id="assessment-medical-takes-otc-meds"
              v-model="medical_meds_otc_takes"
              class="form-check-input"
              type="checkbox"
              value="1"
            >
            <label
              class="form-check-label"
              for="assessment-medical-takes-otc-meds"
            >
              <strong>I take OTC <i
                v-tooltip:top="'Over the counter'"
                class="fa fa-info-circle text-primary d-inline"
              /> medication(s).</strong>
            </label>
          </div>
          <div
            v-show="medical_meds_otc_takes"
            class="form-group mt-3"
          >
            <label for="assessment-medical-otc-meds-desc">What OTC <i
              v-tooltip:top="'Over the counter'"
              class="fa fa-info-circle text-primary d-inline"
            /> medicines do you take?</label>
            <input
              id="assessment-medical-otc-meds-desc"
              v-model="medical_meds_otc_description"
              type="text"
              class="form-control"
              placeholder="List medication(s)"
            >
          </div>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col">
          <p><strong>Lab Results</strong></p>
          <div class="alert alert-info">
            If you have recent lab results available, you can enter applicable information below to get a more accurate score.
          </div>
        </div>
      </div>

      <div
        v-if="general_gender == 'f'"
        class="row"
      >
        <div class="col-md-5 text-md-right">
          <p><strong>Are your Pap Smear test results normal or abnormal?</strong></p>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-pap-normal"
                v-model="medical_labs_pap_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_pap"
                type="radio"
                value="normal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-pap-normal"
              >
                Normal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-pap-abnormal"
                v-model="medical_labs_pap_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_pap"
                type="radio"
                value="abnormal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-pap-abnormal"
              >
                Abnormal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-pap-unknown"
                v-model="medical_labs_pap_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_pap"
                type="radio"
                value="never_administered"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-pap-unknown"
              >
                I have never had a Pap Smear.
              </label>
            </div>
          </div>
          <div
            v-show="medical_labs_pap_results !=='never_administered'"
            class="form-group"
          >
            <label for="assessment-medical-labs-years-since-pap">How many years has it been since your last Pap Smear?</label>
            <div class="row">
              <div class="input-group col-md-5 col-lg-4">
                <input
                  id="assessment-medical-labs-years-since-pap"
                  v-model="medical_labs_pap_years_since"
                  type="number"
                  class="form-control"
                  step="1"
                  min="0"
                >
                <div class="input-group-append">
                  <div class="input-group-text">
                    year(s)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr v-if="general_gender == 'f'">

      <div
        v-if="general_gender == 'f' && age() >= 40"
        class="row"
      >
        <div class="col-md-5 text-md-right">
          <p><strong>Are your Mammogram results normal or abnormal?</strong></p>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-mammogram-normal"
                v-model="medical_labs_mammogram_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_mammogram"
                type="radio"
                value="normal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-mammogram-normal"
              >
                Normal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-mammogram-abnormal"
                v-model="medical_labs_mammogram_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_mammogram"
                type="radio"
                value="abnormal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-mammogram-abnormal"
              >
                Abnormal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-mammogram-unknown"
                v-model="medical_labs_mammogram_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_mammogram"
                type="radio"
                value=""
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-mammogram-unknown"
              >
                I don't know.
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for="assessment-medical-labs-years-since-mammogram">How many years (if any) has it been since your last Mammogram?</label>
            <div class="row">
              <div class="input-group col-md-5 col-lg-4">
                <input
                  id="assessment-medical-labs-years-since-mammogram"
                  v-model="medical_labs_mammogram_years_since"
                  type="number"
                  class="form-control"
                  step="1"
                  min="0"
                >
                <div class="input-group-append">
                  <div class="input-group-text">
                    year(s)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="general_gender == 'f' && age() >= 40">

      <div
        v-if="age() >= 50"
        class="row"
      >
        <div class="col-md-5 text-md-right">
          <p><strong>Are your Colonoscopy results normal or abnormal?</strong></p>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-colonoscopy-normal"
                v-model="medical_labs_colonoscopy_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_colonoscopy"
                type="radio"
                value="normal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-colonoscopy-normal"
              >
                Normal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-colonoscopy-abnormal"
                v-model="medical_labs_colonoscopy_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_colonoscopy"
                type="radio"
                value="abnormal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-colonoscopy-abnormal"
              >
                Abnormal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-colonoscopy-unknown"
                v-model="medical_labs_colonoscopy_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_colonoscopy"
                type="radio"
                value=""
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-colonoscopy-unknown"
              >
                I don't know.
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for="assessment-medical-labs-years-since-colonoscopy">How many years (if any) has it been since your last Colonoscopy?</label>
            <div class="row">
              <div class="input-group col-md-5 col-lg-4">
                <input
                  id="assessment-medical-labs-years-since-colonoscopy"
                  v-model="medical_labs_colonoscopy_years_since"
                  type="number"
                  class="form-control"
                  step="1"
                  min="0"
                >
                <div class="input-group-append">
                  <div class="input-group-text">
                    year(s)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="age() >= 50">

      <div
        v-if="age() >= 50 && general_gender == 'm'"
        class="row"
      >
        <div class="col-md-5 text-md-right">
          <p><strong>Are your Prostate Exam results normal or abnormal?</strong></p>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-prostate-normal"
                v-model="medical_labs_prostate_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_prostate"
                type="radio"
                value="normal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-prostate-normal"
              >
                Normal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-prostate-abnormal"
                v-model="medical_labs_prostate_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_prostate"
                type="radio"
                value="abnormal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-prostate-abnormal"
              >
                Abnormal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-prostate-unknown"
                v-model="medical_labs_prostate_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_prostate"
                type="radio"
                value=""
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-prostate-unknown"
              >
                I don't know.
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for="assessment-medical-labs-years-since-prostate">How many years (if any) has it been since your last Prostate Exam?</label>
            <div class="row">
              <div class="input-group col-md-5 col-lg-4">
                <input
                  id="assessment-medical-labs-years-since-prostate"
                  v-model="medical_labs_prostate_years_since"
                  type="number"
                  class="form-control"
                  step="1"
                  min="0"
                >
                <div class="input-group-append">
                  <div class="input-group-text">
                    year(s)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="age() >= 50 && general_gender == 'm'">

      <div
        v-if="age() >= 40"
        class="row"
      >
        <div class="col-md-5 text-md-right">
          <p><strong>Are your Lipid Panel results normal or abnormal?</strong></p>
        </div>
        <div class="col-md-7">
          <div class="form-group">
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-lipid-panel-normal"
                v-model="medical_labs_lipid_panel_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_lipid_panel"
                type="radio"
                value="normal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-lipid-panel-normal"
              >
                Normal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-lipid-panel-abnormal"
                v-model="medical_labs_lipid_panel_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_lipid_panel"
                type="radio"
                value="abnormal"
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-lipid-panel-abnormal"
              >
                Abnormal
              </label>
            </div>
            <div class="form-check">
              <input
                id="assessment-medicals-labs-results-lipid-panel-unknown"
                v-model="medical_labs_lipid_panel_results"
                class="form-check-input"
                name="assessment_medicals_labs_results_lipid_panel"
                type="radio"
                value=""
                required
              >
              <label
                class="form-check-label"
                for="assessment-medicals-labs-results-lipid-panel-unknown"
              >
                I don't know.
              </label>
            </div>
          </div>
          <div class="form-group">
            <label for="assessment-medical-labs-years-since-lipid-panel">How many years (if any) has it been since your last Lipid Panel?</label>
            <div class="row">
              <div class="input-group col-md-5 col-lg-4">
                <input
                  id="assessment-medical-labs-years-since-lipid-panel"
                  v-model="medical_labs_lipid_panel_years_since"
                  type="number"
                  class="form-control"
                  step="1"
                  min="0"
                >
                <div class="input-group-append">
                  <div class="input-group-text">
                    year(s)
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="age() >= 40">

      <div class="row">
        <div class="col-12">
          <div class="alert alert-info">
            <p>Please be aware that in order to accurately calculate your Favorable Fitness Factor®, we need certain lab values from you. Lab values play a large part in analyzing your health, so if you do not have your scores at the moment, you can take the assessment by leaving any unknown's blank, but should contact your physician shortly after. We highly recommend getting yearly lab tests done. Please understand that if you cannot fill out your lab values at this time, you will have a lower Favorable Fitness Factor® score. This lower score does not indicate that you are unhealthy in any sense, our database is just missing that specific information which calculates a personalized score for you. The necessary lab tests include: Glucose, LDL, HDL, Triglycerides, Cholesterol, HgbA1c and Blood Pressure. Thank you!</p>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-sodium">Sodium</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-sodium"
              v-model="medical_labs_general_sodium"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mEq/L</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-potassium">Potassium</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-potassium"
              v-model="medical_labs_general_potassium"
              type="number"
              class="form-control"
              step=".1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mEq/L</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-phosphorus">Phosphorus</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-phosphorus"
              v-model="medical_labs_general_phosphorus"
              type="number"
              class="form-control"
              step=".1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mg/dL</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-magnesium">Magnesium</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-magnesium"
              v-model="medical_labs_general_magnesium"
              type="number"
              class="form-control"
              step=".1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mg/dL</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-sgot-ast">SGOT/AST</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-sgot-ast"
              v-model="medical_labs_general_sgot_ast"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">IU/L</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-glucose">Glucose</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-glucose"
              v-model="medical_labs_general_glucose"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mg/dl</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-sgpt-alt">SGPT/ALT</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-sgpt-alt"
              v-model="medical_labs_general_sgpt_alt"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">IU/L</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-cholesterol">Cholesterol</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-cholesterol"
              v-model="medical_labs_general_cholesterol"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mg/dL</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-hdl">HDL</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-hdl"
              v-model="medical_labs_general_hdl"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mg/dL</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-ldl">LDL</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-ldl"
              v-model="medical_labs_general_ldl"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mg/dL</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-triglycerides">Triglycerides</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-triglycerides"
              v-model="medical_labs_general_triglycerides"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mg/dL</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-bun">BUN</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-bun"
              v-model="medical_labs_general_bun"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mg/dL</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-creatinine">Creatinine</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-creatinine"
              v-model="medical_labs_general_creatinine"
              type="number"
              class="form-control"
              step=".1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mg/dL</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-bun-to-creatine">BUN to Creatinine ratio</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-bun-to-creatine"
              v-model="medical_labs_general_bun_to_creatinine"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">:1</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-hgb">Hgb</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-hgb"
              v-model="medical_labs_general_hgb"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">g/dL</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-hgb">Hct</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-hct"
              v-model="medical_labs_general_hct"
              type="number"
              class="form-control"
              step="1"
            >
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-hgba1c">HgbA1c</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-hgba1c"
              v-model="medical_labs_general_hgba1c"
              type="number"
              class="form-control"
              step=".1"
            >
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-6 col-md-4 col-lg-3">
          <label for="assessment-medical-labs-results-tsh">TSH</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-tsh"
              v-model="medical_labs_general_tsh"
              type="number"
              class="form-control"
              step=".1"
            >
            <div class="input-group-append">
              <span class="input-group-text">mIU/L</span>
            </div>
          </div>
        </div>
        <div class="form-group mt-3 col-sm-4 col-md-4 col-lg-2">
          <label for="assessment-medical-labs-results-bone-density">Bone Density</label>
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-bone-density"
              v-model="medical_labs_general_bone_density"
              type="number"
              class="form-control"
              step=".1"
              max="0"
            >
            <!-- <div class="input-group-append">
                            <span class="input-group-text"></span>
                        </div> -->
          </div>
        </div>
        <div class="form-group mt-3 col-sm-8 col-md-8 col-lg-4">
          <label for="assessment-medical-labs-results-blood-pressure-systolic">Blood Pressure</label>    
          <div class="input-group">
            <input
              id="assessment-medical-labs-results-blood-pressure-systolic"
              v-model="medical_labs_general_blood_pressure_systolic"
              type="number"
              min="0"
              step="1"
              class="form-control"
            >
            <div class="input-group-append input-group-prepend">
              <span class="input-group-text">/</span>
            </div>
            <input
              id="assessment-medical-labs-results-blood-pressure-diastolic"
              v-model="medical_labs_general_blood_pressure_diastolic"
              type="number"
              min="0"
              step="1"
              class="form-control"
            >
            <div class="input-group-append input-group-append">
              <span class="input-group-text">mmHg</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'GET_DATA_FIELD',
  mutationType: 'UPDATE_DATA_FIELD',
});

export default {
  computed: {
    ...mapFields('healthData', {
      'general_birthdate': 'general.birthdate',
      'general_gender': 'general.gender',
      'medical_conditions_diabetes_has': 'medical.conditions.diabetes.has',
      'medical_conditions_diabetes_takes_insulin': 'medical.conditions.diabetes.takes_insulin',
      'medical_conditions_diabetes_on_insulin_pump': 'medical.conditions.diabetes.on_insulin_pump',
      'medical_conditions_diabetes_takes_meds': 'medical.conditions.diabetes.takes_meds',
      'medical_conditions_diabetes_meds': 'medical.conditions.diabetes.meds',
      'medical_conditions_prediabetes_has': 'medical.conditions.prediabetes.has',
      'medical_conditions_prediabetes_takes_meds': 'medical.conditions.prediabetes.takes_meds',
      'medical_conditions_prediabetes_meds': 'medical.conditions.prediabetes.meds',
      'medical_conditions_hypertension_has': 'medical.conditions.hypertension.has',
      'medical_conditions_hypertension_takes_meds': 'medical.conditions.hypertension.takes_meds',
      'medical_conditions_hypertension_meds': 'medical.conditions.hypertension.meds',
      'medical_conditions_kidney_disease_has': 'medical.conditions.kidney_disease.has',
      'medical_conditions_kidney_disease_takes_meds': 'medical.conditions.kidney_disease.takes_meds',
      'medical_conditions_kidney_disease_meds': 'medical.conditions.kidney_disease.meds',
      'medical_conditions_heart_disease_has': 'medical.conditions.heart_disease.has',
      'medical_conditions_heart_disease_had_stroke': 'medical.conditions.heart_disease.had_stroke',
      'medical_conditions_heart_disease_had_heart_attack': 'medical.conditions.heart_disease.had_heart_attack',
      'medical_conditions_heart_disease_takes_meds': 'medical.conditions.heart_disease.takes_meds',
      'medical_conditions_heart_disease_meds': 'medical.conditions.heart_disease.meds',
      'medical_conditions_high_blood_fats_has': 'medical.conditions.high_blood_fats.has',
      'medical_conditions_high_blood_fats_takes_meds': 'medical.conditions.high_blood_fats.takes_meds',
      'medical_conditions_high_blood_fats_meds': 'medical.conditions.high_blood_fats.meds',
      'medical_conditions_liver_disease_has': 'medical.conditions.liver_disease.has',
      'medical_conditions_liver_disease_takes_meds': 'medical.conditions.liver_disease.takes_meds',
      'medical_conditions_liver_disease_meds': 'medical.conditions.liver_disease.meds',
      'medical_conditions_cancer_has': 'medical.conditions.cancer.has',
      'medical_conditions_cancer_takes_meds': 'medical.conditions.cancer.takes_meds',
      'medical_conditions_cancer_meds': 'medical.conditions.cancer.meds',
      'medical_conditions_cancer_has_had': 'medical.conditions.cancer.has_had',
      'medical_conditions_cancer_in_remission_for': 'medical.conditions.cancer.in_remission_for',
      'medical_family_history_diabetes': 'medical.family_history.diabetes',
      'medical_family_history_hypertension': 'medical.family_history.hypertension',
      'medical_family_history_kidney_disease': 'medical.family_history.kidney_disease',
      'medical_family_history_heart_disease': 'medical.family_history.heart_disease',
      'medical_family_history_high_blood_fats': 'medical.family_history.high_blood_fats',
      'medical_family_history_liver_disease': 'medical.family_history.liver_disease',
      'medical_family_history_cancer': 'medical.family_history.cancer',
      'medical_meds_herbal_takes': 'medical.meds.herbal.takes',
      'medical_meds_herbal_description': 'medical.meds.herbal.description',
      'medical_meds_otc_takes': 'medical.meds.otc.takes',
      'medical_meds_otc_description': 'medical.meds.otc.description',
      'medical_labs_pap_results': 'medical.labs.pap.results',
      'medical_labs_mammogram_results': 'medical.labs.mammogram.results',
      'medical_labs_colonoscopy_results': 'medical.labs.colonoscopy.results',
      'medical_labs_prostate_results': 'medical.labs.prostate.results',
      'medical_labs_lipid_panel_results': 'medical.labs.lipid_panel.results',
      'medical_labs_pap_years_since': 'medical.labs.pap.years_since',
      'medical_labs_mammogram_years_since': 'medical.labs.mammogram.years_since',
      'medical_labs_colonoscopy_years_since': 'medical.labs.colonoscopy.years_since',
      'medical_labs_prostate_years_since': 'medical.labs.prostate.years_since',
      'medical_labs_lipid_panel_years_since': 'medical.labs.lipid_panel.years_since',
      'medical_labs_general_sodium': 'medical.labs.general.sodium',
      'medical_labs_general_potassium': 'medical.labs.general.potassium',
      'medical_labs_general_phosphorus': 'medical.labs.general.phosphorus',
      'medical_labs_general_magnesium': 'medical.labs.general.magnesium',
      'medical_labs_general_sgot_ast': 'medical.labs.general.sgot_ast',
      'medical_labs_general_glucose': 'medical.labs.general.glucose',
      'medical_labs_general_sgpt_alt': 'medical.labs.general.sgpt_alt',
      'medical_labs_general_cholesterol': 'medical.labs.general.cholesterol',
      'medical_labs_general_hdl': 'medical.labs.general.hdl',
      'medical_labs_general_ldl': 'medical.labs.general.ldl',
      'medical_labs_general_triglycerides': 'medical.labs.general.triglycerides',
      'medical_labs_general_bun': 'medical.labs.general.bun',
      'medical_labs_general_creatinine': 'medical.labs.general.creatinine',
      'medical_labs_general_bun_to_creatinine': 'medical.labs.general.bun_to_creatinine',
      'medical_labs_general_hgb': 'medical.labs.general.hgb',
      'medical_labs_general_hct': 'medical.labs.general.hct',
      'medical_labs_general_hgba1c': 'medical.labs.general.hgba1c',
      'medical_labs_general_tsh': 'medical.labs.general.tsh',
      'medical_labs_general_bone_density': 'medical.labs.general.bone_density',
      'medical_labs_general_blood_pressure_systolic': 'medical.labs.general.blood_pressure.systolic',
      'medical_labs_general_blood_pressure_diastolic': 'medical.labs.general.blood_pressure.diastolic',
    })
  },
  watch: {
    medical_labs_pap_results: function (newVal, oldVal) {
      if (newVal =='never_administered'){
        this.medical_labs_pap_years_since = null;
      }
    }
  },
  methods: {
    age() {
      if (this.general_birthdate) {
        return moment().diff(moment(this.general_birthdate, 'MM/DD/YYYY'), 'years')
      } else {
        return 0;
      }
    }
  }
}
</script>
